// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._0QLVzoHQFE1Gx_zdlDE {
  margin: 15px 0;
  border-top: 1px solid #e3e3e3;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/components/divider/divider.module.scss"],"names":[],"mappings":"AACA;EACI,cAAA;EACA,6BAAA;AAAJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.divider {\n    margin: 15px 0;\n    border-top: 1px solid $border-gray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `_0QLVzoHQFE1Gx_zdlDE`
};
export default ___CSS_LOADER_EXPORT___;
